export { useGetExtensionActivityDetailsQuery } from '../../types/generated/types-orchestration'

export type { ExtensionActivityRecord } from '../../types/generated/types-orchestration'
